import { Collapse } from '@material-ui/core';
import { map } from 'lodash';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { FaGlobeAmericas, FaChevronDown } from 'react-icons/fa';
import Settings from '../../Managers/Settings';
import "./Language.css"

export const LanguageSelector = () => {
    const ref = useRef()
    
    const options = [
        {
            title: "English",
            code: 'en'
        },
        {
            title: "Spanish",
            code: 'es'
        },
        {
            title: "ASL",
            code: 'asl'
        }
    ]
    const [value, setValue] = useState(options[0])
    const [open, setOpen] = useState(false)

    const toggle = () => {
        setOpen(!open)
    }

    const close = () => {
        setOpen(false)
    }

    useClickOutside(ref, close)

    const onSelect = (option: {title: string, code: string}) => {
        setValue(option)
        Settings.setLanguage(option.code)
        toggle()
    }

    return(
        <div className="language-outer-container" ref={ref} >
            <div className="language-button-container" onClick={toggle}>
                <FaGlobeAmericas color="white" size={14} />
                <div className="language-title">
                    {value.title}
                </div>
                <FaChevronDown color="white" size={14} />
            </div>
            <Collapse in={open} timeout={100}>
                <div 
                    className="language-options"
                    >
                        {map(options, (option, i) => {
                            const select = () => onSelect(option)
                            return(
                                <div 
                                key={`language-selector-${i}`}
                                onClick={select}
                                    className="language-option">
                                    {option.title}
                                </div>
                            )
                        })}
                </div>
            </Collapse>
        </div>
    )
}

export const useClickOutside = (ref, callback) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback()
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, callback]);
}